import styled from 'styled-components';

export const Root = styled.div`
  height: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
`;
